// extracted by mini-css-extract-plugin
export default {"root":"UpdateDurationButton_root__cD05x","button":"UpdateDurationButton_button__cUT9V"};